<template>
  <div id="faq">
      <h3>Frequently Asked Questions</h3>
      <span>Here are some common inquiries about MealTrips and their respective answers. &#128525;</span>
      <tabs class="tabs">
      <tab title="For Customers" class="tab">
          <Accordion />
      </tab>
      <tab title="For Vendors" class="tab">
          <Vendors />
      </tab>
    </tabs>
  </div>
</template>

<script>
import Tab from './Tab.vue'
import Tabs from './Tabs.vue'
import Accordion from './Accordion.vue'
import Vendors from './Vendors.vue'

export default {
    name: 'Faq',
    components: {
        Tab,
        Tabs,
        Accordion,
        Vendors
    }
}
</script>

<style lang="scss" scoped>
#faq{
    background: #fff;
    height: 180vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: 'Raleway', sans-serif;
    h3{
        font-size: 36px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
    }
    span{
        font-size: 24px;
        width: 500px;
        text-align: center;
        margin-bottom: 80px;
    }
    .tab{
        margin-top: 30px;
        width: 550px;
        overflow-y: scroll;
        max-height: 400px;
    }
    ::-webkit-scrollbar{
        background: #F1F6F9;
    }
    ::-webkit-scrollbar-thumb{
    background: #FFC727;
    border-radius: 32px;
    }
}

@media (max-width: 480px) {
    #faq{
    background: #fff;
    height: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: 'Raleway', sans-serif;
    padding-top: 80px;
    font-size: 16px;
    h3{
        font-size: 22px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
        text-align: center;
    }
    span{
        font-size: 18px;
        width: 80%;
        text-align: center;
        margin-bottom: 80px;
    }
    .tabs{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 80px;
        padding: 0 8%;
    }
    .tab{
        margin-top: 30px;
        width: 90%;
        overflow-y: scroll;
        max-height: 400px;
    }
    ::-webkit-scrollbar{
        background: #F1F6F9;
    }
    ::-webkit-scrollbar-thumb{
    background: #FFC727;
    border-radius: 32px;
    }
}
}

@media (min-width: 481px) and (max-width: 768px) {
    #faq{
    background: #fff;
    height: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: 'Raleway', sans-serif;
    padding-top: 80px;
    font-size: 16px;
    h3{
        font-size: 22px;
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
        text-align: center;
    }
    span{
        font-size: 18px;
        width: 80%;
        text-align: center;
        margin-bottom: 80px;
    }
    .tabs{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 80px;
        padding: 0 8%;
    }
    .tab{
        margin-top: 30px;
        width: 90%;
        overflow-y: scroll;
        max-height: 400px;
    }
    ::-webkit-scrollbar{
        background: #F1F6F9;
    }
    ::-webkit-scrollbar-thumb{
    background: #FFC727;
    border-radius: 32px;
    }
}
}

@media (min-width: 769px) and (max-width: 1024px) {
    #faq{
    height: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: 'Raleway', sans-serif;
    padding-top: 80px;
    h3{
        font-weight: 400;
        font-family: 'Abril Fatface', cursive;
        color: #4D8EA8;
        margin-bottom: 16px;
        text-align: center;
    }
    span{
        width: 80%;
        text-align: center;
        margin-bottom: 80px;
    }
    .tabs{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 80px;
        padding: 0 8%;
        margin-bottom: 150px;
    }
    .tab{
        margin-top: 30px;
        width: 90%;
        overflow-y: scroll;
        max-height: 400px;
    }
}
}
</style>